/**
  * Creates a string that contains a countdown definition
  * @param {string} prefix - text to be concatenated in front of countdown definition (optional)
  * @param {string} type - countdown type
  * @param {string} date - countdown end date (optional, defaults to 'yyyy/MM/dd')
  * @param {string} time - countdown end time (optional, defaults to 'HH:mm:ss')
  * @param {string} language - countdown language
  * @param {string} days - duration of countdown in days
  * @param {string} suffix - text to be concatenated at the end of countdown definition (optional)
  * @param {string} isResponsiveSearchAd - boolean
  * @returns {string} formatted string
  */
export function formatCountdown(
  prefix, type, date, time, language,
  days, suffix, isResponsiveSearchAd
) {
  let ret;
  if (isResponsiveSearchAd) {
    ret = '{prefix}{{type}({date} {time},{days})}{suffix}';
  } else {
    ret = '{prefix}{={type}("{date} {time}", "{language}", {days})}{suffix}';
  }

  ret = ret.replace('{prefix}', prefix || '');
  ret = ret.replace('{type}', type);
  ret = isResponsiveSearchAd ? ret.replace('{date}', date || 'yyyy-MM-dd') : ret.replace('{date}', date || 'yyyy/MM/dd');
  ret = ret.replace('{time}', time || 'HH:mm:ss');
  ret = ret.replace('{language}', language);
  ret = ret.replace('{days}', days);
  ret = ret.replace('{suffix}', suffix || '');

  return ret;
}
export const defaultCountdownDays = 5;
